import { defineMessages } from 'react-intl'

export default defineMessages({
  dropZoneDescription: {
    id: 'Form.FileDragAndDrop.DropZoneDescription',
    defaultMessage: 'Click here or drag file'
  }
})
